import React from 'react'
import classNames from 'classnames'

const Col = ({xs, sm, md, lg, xl, className, children}) => {
  const classes = classNames('col', {
	[`${className}`]: className,
	[`col`]: !xs && !sm && !md && !lg && !xl,
    [`col-${xs}`]: xs,
    [`col-sm-${sm}`]: sm,
    [`col-md-${md}`]: md,
    [`col-lg-${lg}`]: lg,
    [`col-xl-${xl}`]: xl,
  })

  return (
    <div className={classes}>{children}</div>
  )
}

export default Col
